import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Tooltip, Input, Typography } from "antd";
import axios from "axios";
import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

const ProvisionDamageForm = props => {
  const [form] = Form.useForm();
  const isEditMode = props.isEditMode || false;
  const isBusiness = props.enterpriseType === 'BUSINESS';

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  useEffect(() => {
    if (props.record.damage) {
      form.setFieldsValue({
        additionalVeterinary: props.record.damage.additionalVeterinary,
        additionalFood: props.record.damage.additionalFood,
        lossesFees: props.record.damage.lossesFees,
        lossesValue: props.record.damage.lossesValue,
        relocationCost: props.record.damage.relocationCost,
        lossesPrematureSale: props.record.damage.lossesPrematureSale,
        replantingCost: props.record.damage.replantingCost,
        additionalMaterials: props.record.damage.additionalMaterials,
        restorationCost: props.record.damage.restorationCost,
      });
    }
  }, [props.record.damage, form]);

  const onValuesChange = (changedValues) => {
    form.validateFields(Object.keys(changedValues));
  };

  const onFieldsChange = (changedFields, allFields) => {
    if (!isEditMode) return;
    const fieldsError = form.getFieldsError();
    var valid = fieldsError.every(field => !field.errors || field.errors.length === 0);
    
    const values = form.getFieldsValue();
    const newDamage = { ...props.record };
    newDamage.damage.additionalVeterinary = elvis(values.additionalVeterinary);
    newDamage.damage.additionalFood = elvis(values.additionalFood);
    newDamage.damage.lossesFees = elvis(values.lossesFees);
    newDamage.damage.lossesValue = elvis(values.lossesValue);
    newDamage.damage.relocationCost = elvis(values.relocationCost);
    newDamage.damage.lossesPrematureSale = elvis(values.lossesPrematureSale);
    newDamage.damage.replantingCost = elvis(values.replantingCost);
    newDamage.damage.additionalMaterials = elvis(values.additionalMaterials);
    newDamage.damage.restorationCost = elvis(values.restorationCost);
    newDamage.valid = valid;
    props.parentCallback(newDamage);
  };

  return (
    <Form 
      {...formItemLayout} 
      className="details_form"
      form={form}
      onValuesChange={onValuesChange}
      onFieldsChange={onFieldsChange}
      name="provisionDamage"
    >
      <Title className="details_form_header"
        title="Damages details"
        subTitle="Provision"
      />
      {!isBusiness && (
        <Form.Item label="Costs of Additional Veterinary Expenses (€)" name="additionalVeterinary">
          <InputNumber disabled={!isEditMode} />
        </Form.Item>
      )}
      {!isBusiness && (
        <Form.Item label="Costs of Additional Food (€)" name="additionalFood">
          <InputNumber disabled={!isEditMode} />
        </Form.Item>
      )}
      <Form.Item label="Losses from fees (€)" name="lossesFees">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      {isBusiness && (
        <Form.Item label="Costs of additional materials (€)" name="additionalMaterials">
          <InputNumber disabled={!isEditMode} />
        </Form.Item>
      )}
      <Form.Item label="Losses of added value (€)" name="lossesValue">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      <Form.Item label="Costs of relocation (€)" name="relocationCost">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      <Form.Item label="Premature sales (€)" name="lossesPrematureSale">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      {isBusiness && (
        <Form.Item label="Costs of restoration (€)" name="restorationCost">
          <InputNumber disabled={!isEditMode} />
        </Form.Item>
      )}
      {!isBusiness && (
        <Form.Item label="Costs of Replanting (€)" name="replantingCost">
          <InputNumber disabled={!isEditMode} />
        </Form.Item>
      )}
    </Form>
  );
};

export default ProvisionDamageForm;